//混入方法,定义通用方法
const mixinModel = {
	data() {
		return {			
			dataurl:this.$utils.Url.s400 + '/api/S400Bq405/AllList',
		}
	},
	props: {

	},
	computed: {

	},
	methods: {
		setFormData: function(data) {
			this.$utils.CopyAllPro(data, this.form[this.modelname])
		},
		//加载检查项信息
		LoadDataList: function() {
			var that = this
			var data = {
				bq405004: this.modelname,
				currentPage: 1,
				pageSize: 1000
			}
			that.$utils.HttpPost(that.dataurl, data, function(d) {
				that.dataList = []
				d.Data.forEach(item => {
					that.dataList.push({
						guid: item.guid,
						name: item.Bq405_003,
						controlList: item.Bq405_005.split(','),
						propList: item.Bq405_006.split(','),
						unitList: item.Bq405_007.split(','),
						referenceValue: item.Bq405_008.split(','),
					})
				})
			}, null, null, null);
		},
    //保存按钮成功回调事件
    saveSucess: function() {
      //调用列表页的closeDialog方法
      this.$emit("closePage","")
    },
	}
}

export default mixinModel
